<ng-container *ngIf="noHistory; else historyTable">
  <p><em>No workshop history found for this item.</em></p>
</ng-container>
<ng-template #historyTable>
  <table mat-table [dataSource]="rows$">
    <tr mat-header-row *matHeaderRowDef="columns"></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef>ID</th>
      <td mat-cell *matCellDef="let row">
        <a (click)="viewJob(row.id)">
          {{ row.id }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let row">{{ row.type | titlecase }}</td>
    </ng-container>

    <ng-container matColumnDef="booked_in_at">
      <th mat-header-cell *matHeaderCellDef>Booked in</th>
      <td mat-cell *matCellDef="let row">
        {{ row.booked_in_at | amDateFormat : dateFormat }}
      </td>
    </ng-container>

    <ng-container matColumnDef="work_status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let row">
        {{ row.work_status | workshopJobStatusLabel }}
      </td>
    </ng-container>

    <ng-container matColumnDef="labour">
      <th mat-header-cell *matHeaderCellDef>Labour</th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.labour_hours">
          {{ row.labour_hours }} hours,
          {{ row.labour_cost | hlCurrency | async }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="total_cost">
      <th mat-header-cell *matHeaderCellDef>Total cost</th>
      <td mat-cell *matCellDef="let row">
        {{ row.total_cost | hlCurrency | async }}
      </td>
    </ng-container>
  </table>
</ng-template>

<div class="flex flex-row justify-center items-center my-4 w-full">
  <button
    mat-flat-button
    color="primary"
    (click)="addWorkshopJob()"
    data-cy="add-workshop-job"
  >
    Add workshop job
  </button>
</div>
